import { GET_RECURRING_PAYABLES_SUCCESS } from '../recurringPayables/store/recurringPayables.types';
import {
  GET_APPROVED_LINE_ITEM_REPORTS_SUCCESS,
  GET_EXPENSE_SUMMARIES_SUCCESS,
  GET_VOUCHER_SUMMARIES_FAILURE,
  GET_VOUCHER_SUMMARIES_REQUEST,
  GET_VOUCHER_SUMMARIES_SUCCESS,
  SET_CURRENT_EXPENSE_ID,
  SET_CURRENT_RECURRING_PAYABLE_ID,
  SET_CURRENT_VOUCHER_ID
} from './types';
import produce from 'immer';

const initialState = {
  expenseSummaries: null,
  voucherSummaries: null,
  expenseLines: null,
  isLoadingExpenseSummaries: false,
  isLoadingVoucherSummaries: false,
  isLoadingExpenseLines: false,
  approvedLineItemReports: []
};

export default produce((draft = initialState, action) => {
  switch (action.type) {
    case GET_EXPENSE_SUMMARIES_SUCCESS:
      draft.expenseSummaries = action.response;
      break;

    case GET_VOUCHER_SUMMARIES_REQUEST:
      draft.isLoadingVoucherSummaries = true;
      break;

    case GET_VOUCHER_SUMMARIES_SUCCESS:
      draft.isLoadingVoucherSummaries = false;
      draft.voucherSummaries = action.response;
      break;

    case GET_VOUCHER_SUMMARIES_FAILURE:
      draft.isLoadingVoucherSummaries = false;
      break;

    case GET_RECURRING_PAYABLES_SUCCESS:
      draft.recurringPayables = Array.isArray(action.response) ? action.response : [];
      break;

    case SET_CURRENT_VOUCHER_ID:
      draft.voucherId = action.response;
      break;

    case SET_CURRENT_EXPENSE_ID:
      draft.expenseId = action.response;
      break;

    case SET_CURRENT_RECURRING_PAYABLE_ID:
      draft.recurringPayableId = action.response;
      break;

    case GET_APPROVED_LINE_ITEM_REPORTS_SUCCESS:
      draft.approvedLineItemReports = Array.isArray(action.response) ? action.response : [];
      break;

    default:
      break;
  }

  return draft;
}, initialState);
